import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from '../utils/icons';
import { FaLinkedinIn } from 'react-icons/fa';
import { useI18n } from '../i18n';

const Projects = () => {
  const { t } = useI18n();

  const projects = [
    {
      code: 'PRD-01',
      title: t('projectsPage.items.crespoguard.title'),
      description: t('projectsPage.items.crespoguard.desc'),
      logo: '/images/logos/crespoguard.png',
      status: t('home.projects.status.active'),
      scope: t('home.projects.items.crespoguard.scope'),
      href: 'https://crespoguard.com',
      detail: t('projectsPage.details.crespoguard'),
    },
    {
      code: 'PRD-02',
      title: t('projectsPage.items.nomnomad.title'),
      description: t('projectsPage.items.nomnomad.desc'),
      logo: '/images/logos/nomnomad.webp',
      status: t('home.projects.status.wip'),
      scope: t('home.projects.items.nomnomad.scope'),
      href: 'https://nomnomad.ai',
      detail: t('projectsPage.details.nomnomad'),
    },
  ];

  const approachValue = t('projectsPage.approach.items');
  const approach = Array.isArray(approachValue) ? approachValue : [];

  const fadeUp = {
    hidden: { opacity: 1, y: 18 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div className="pt-20 ccc-site min-h-screen">
      <section className="ccc-brief-hero">
        <div className="ccc-container py-16 md:py-20">
          <p className="ccc-eyebrow mb-5">{t('ui.productPortfolio')}</p>
          <h1 className="ccc-brief-title">{t('projectsPage.hero.title')}</h1>
          <p className="ccc-brief-copy mt-6 max-w-3xl">{t('projectsPage.hero.subtitle')}</p>
        </div>
      </section>

      <section className="ccc-section">
        <div className="ccc-container">
          <div className="grid gap-6">
            {projects.map((project) => (
              <motion.article
                key={project.code}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                className="ccc-product-panel"
              >
                <div>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="ccc-pill">{project.code}</span>
                    <span className="ccc-pill">{project.status}</span>
                    <span className="ccc-pill">{project.scope}</span>
                  </div>
                  <h2 className="mt-6 text-3xl font-black text-slate-950 md:text-5xl">{project.title}</h2>
                  <p className="ccc-work-copy mt-5 max-w-3xl">{project.description}</p>
                  <div className="mt-7 border-t border-slate-200 pt-5">
                    <p className="ccc-label">{t('ui.operatingNote')}</p>
                    <p className="ccc-value mt-2">{project.detail}</p>
                  </div>
                  <a
                    href={project.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ccc-link mt-6 inline-block text-sm"
                  >
                    {t('ui.visitSite')}
                  </a>
                </div>
                <div className="ccc-logo-tile">
                  <img src={project.logo} alt={project.title} className="max-h-28 max-w-[13rem] object-contain" />
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="ccc-section bg-[#e1e9e5]">
        <div className="ccc-container">
          <div className="ccc-section-head">
            <div>
              <p className="ccc-eyebrow mb-4">{t('ui.buildStandard')}</p>
              <h2 className="ccc-section-title">{t('projectsPage.approach.title')}</h2>
            </div>
            <p className="ccc-section-copy">{t('projectsPage.hero.subtitle')}</p>
          </div>
          <div className="ccc-scope-grid">
            {approach.map((step, index) => (
              <article key={step.title} className="ccc-scope-cell">
                <p className="ccc-scope-number">{String(index + 1).padStart(2, '0')}</p>
                <h3 className="ccc-scope-title">{step.title}</h3>
                <p className="ccc-scope-copy">{step.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ccc-section-tight">
        <div className="ccc-container">
          <div className="ccc-ledger-dark p-6 md:p-8">
            <div className="grid gap-7 md:grid-cols-[minmax(0,0.8fr)_auto] md:items-center">
              <div>
                <p className="ccc-label mb-3">{t('ui.portfolioContact')}</p>
                <h2 className="text-3xl font-black md:text-5xl">{t('projectsPage.cta.title')}</h2>
                <p className="mt-4 max-w-2xl text-slate-300">{t('projectsPage.cta.subtitle')}</p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <a
                  href="https://www.linkedin.com/in/miguel083"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ccc-primary-btn px-5 py-3"
                >
                  <FaLinkedinIn className="h-5 w-5" />
                  {t('projectsPage.cta.linkedin')}
                </a>
                <a href="mailto:info@crespocyberconsulting.com" className="ccc-secondary-btn px-5 py-3">
                  {t('projectsPage.cta.contact')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
